import * as React from 'react';

import {Shop} from 'interfaces';
import ShopTile from './components/ShopTile';

export interface ShopGridProps {
  shops: Shop[];
}

export function ShopGrid({shops}: ShopGridProps) {
  return (
    <React.Fragment>
      {shops.map((shop) => (
        <ShopTile
          key={shop.handle}
          shop={shop}
        />
      ))}
    </React.Fragment>
  );
}

export default ShopGrid;
